import * as React from 'react';
import { useEffect } from 'react';
import { CONTACT_US_FORMS } from '../footer/helpers';

export default function ContactUsForm({modalType}: { modalType: CONTACT_US_FORMS }) {
	useEffect(() => {
		const script = document.createElement('script');
		script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
		script.type = 'text/javascript';
		script.async = true;
		const container = document.getElementById('contactus-container');
		let loadedForm;

		// Callback to handle form initialization
		script.onload = function () {
			//@ts-ignore
			hbspt.forms.create({
				region: 'eu1',
				portalId: '143794975',
				formId: modalType === CONTACT_US_FORMS.BIKE
          ? '51eb5f35-a6cd-4693-ab77-2914f5297db8'
          : '1275d9b3-c94b-4809-ba61-ea5899089a34',
			});
			console.log('----------');
			const checkForm = setInterval(() => {
				loadedForm = document.querySelector('.hbspt-form');
				if (loadedForm && container) {
					container.appendChild(loadedForm);
          container.style.overflowY = 'auto';
          container.style.height = '80vh';
					clearInterval(checkForm); // Stop checking once the form is loaded
				}
			}, 100); // Check every 100ms
		};

		// Append the script to the document head
		document.head.appendChild(script);

		// Clean-up logic: Remove the form and script on unmount
		return () => {
			if (loadedForm && container.contains(loadedForm)) {
				container.removeChild(loadedForm);
			}
			document.head.removeChild(script); // Remove the script when the component unmounts
		};
	}, []);

	return <div id={'contactus-container'}></div>;
}
